import React from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Stack,
} from "@mui/material";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

/* utils */
const formatDate = (date) => `${date.getMonth() + 1}/${date.getDate()}`;

const generateSampleData = () => {
  let data = [];
  let volume = 8000;

  for (let i = 6; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);

    volume -= Math.round(Math.random() * (1600 - 1200) + 1200);
    if (i === 3) volume += 5000;

    data.push({
      date: formatDate(date),
      volume: Math.round(volume),
      ullage: Math.round(10000 - volume),
    });
  }
  return data;
};

const sampleData = generateSampleData();

const ChartDemo = () => {
  return (
    <Box component="section" sx={{ py: 10 }}>
      <Grid container spacing={6} alignItems="center">
        {/* Copy */}
        <Grid item xs={12} md={6}>
          <Stack spacing={3}>
            <Typography
              variant="h2"
              sx={{ fontWeight: 900, color: "#fff", fontFamily: "Poppins" }}
            >
              Visualize Your Tank Data
            </Typography>

            <Typography
              variant="h4"
              sx={{ color: "rgba(226,232,240,0.8)", maxWidth: 480 }}
            >
              View historical inventory trends across configurable time ranges.
              Volume vs. ullage charts help predict deliveries, identify abnormal
              losses, and verify reconciliation accuracy.
            </Typography>
          </Stack>
        </Grid>

        {/* Chart */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={8}
            sx={{
              p: 3,
              borderRadius: 4,
              bgcolor: "rgba(15,23,42,0.85)",
              border: "1px solid rgba(148,163,184,0.25)",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ color: "#fff", fontWeight: 700, mb: 2 }}
            >
              Volume vs Ullage
            </Typography>

            <Box sx={{ width: "100%", height: 260 }}>
              <ResponsiveContainer>
                <LineChart data={sampleData}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
                  <XAxis dataKey="date" stroke="#cbd5f5" />
                  <YAxis
                    yAxisId="left"
                    stroke="#60a5fa"
                    label={{ value: "Volume", angle: -90, position: "insideLeft" }}
                  />
                  <YAxis
                    yAxisId="right"
                    orientation="right"
                    stroke="#34d399"
                    label={{ value: "Ullage", angle: 90, position: "insideRight" }}
                  />
                  <Tooltip />
                  <Line
                    yAxisId="left"
                    type="monotone"
                    dataKey="volume"
                    stroke="#60a5fa"
                    strokeWidth={2}
                  />
                  <Line
                    yAxisId="right"
                    type="monotone"
                    dataKey="ullage"
                    stroke="#34d399"
                    strokeWidth={2}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChartDemo;
